import { Book, Bot, Flow, Forum, Mobile, Task } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';
import { rolesFor } from './permissions';

/**
 * AI-администратор (модуль 2, Приложение D): панель оператора и задачи (АДМ-60…64, матрица 2.2 «Диалоги с
 * пациентами, эскалации»: FRONT_DESK — изменение; OWNER, MED_DIR, OPS_DIR — чтение), база знаний (АДМ-02…04,
 * «Прайс, услуги, база знаний»), настройки бота с предпросмотром, автоматика и подключение WhatsApp
 * (АДМ-01, АДМ-40…42, АДМ-50…56, «Настройки AI-администратора»: OWNER, MED_DIR — изменение; FRONT_DESK — чтение).
 * Адреса совпадают со ссылками бэкенда: /assistant/conversations (push об эскалации), /assistant/tasks,
 * /assistant/knowledge и /assistant/settings (чек-лист запуска), /settings/whatsapp (уведомления о шаблонах).
 */
const conversations = rolesFor('conversations');
const settings = rolesFor('assistant_settings');

export const sections = [
  defineSection({
    id: 'assistant.operator',
    area: 'clinic',
    path: 'assistant/conversations/*',
    roles: conversations,
    icon: Forum,
    titleKey: 'assistant:operator.title',
    namespaces: ['schedule', 'portal'],
    navGroup: 'work',
    order: 30,
    load: () => import('./operator/OperatorPage'),
    // Сколько пациентов ждут человека — числом у пункта меню, красным при красном флаге.
    navCounter: () => import('./operator/NavCounter'),
    // Звук и уведомление о новой эскалации на любом экране портала (АДМ-63): только у тех, кто отвечает пациентам.
    shellListener: () => import('./alerts/EscalationAlerts'),
  }),
  defineSection({
    id: 'assistant.tasks',
    area: 'clinic',
    path: 'assistant/tasks',
    roles: conversations,
    icon: Task,
    titleKey: 'assistant:tasks.title',
    namespaces: ['portal'],
    navGroup: 'work',
    order: 40,
    load: () => import('./tasks/TasksPage'),
  }),
  defineSection({
    id: 'assistant.knowledge',
    area: 'clinic',
    path: 'assistant/knowledge/*',
    roles: rolesFor('catalog'),
    // Врач читает базу знаний по ссылке, но в его меню «Настройки бота» нет (DESIGN.md 1.6).
    navRoles: rolesFor('catalog').filter((role) => role !== 'DOCTOR'),
    icon: Book,
    titleKey: 'assistantKb:title',
    namespaces: ['assistant', 'portal'],
    navGroup: 'bot',
    order: 10,
    tabTitleKey: 'shell:tabs.knowledge',
    tabGroup: 'knowledge',
    load: () => import('./knowledge/KnowledgePage'),
  }),
  defineSection({
    id: 'assistant.settings',
    area: 'clinic',
    path: 'assistant/settings/*',
    roles: settings,
    icon: Bot,
    titleKey: 'assistantSettings:settings.title',
    namespaces: ['assistant', 'portal'],
    navGroup: 'bot',
    order: 30,
    tabTitleKey: 'shell:tabs.botSettings',
    tabGroup: 'botSettings',
    load: () => import('./settings/BotSettingsPage'),
  }),
  defineSection({
    id: 'assistant.automations',
    area: 'clinic',
    path: 'assistant/automations/*',
    roles: settings,
    icon: Flow,
    titleKey: 'assistantSettings:automations.title',
    namespaces: ['assistant', 'portal'],
    navGroup: 'bot',
    order: 20,
    load: () => import('./automations/AutomationsPage'),
  }),
  defineSection({
    id: 'assistant.whatsapp',
    area: 'clinic',
    path: 'assistant/whatsapp',
    roles: settings,
    icon: Mobile,
    titleKey: 'assistantSettings:whatsapp.title',
    namespaces: ['assistant', 'portal'],
    navGroup: 'bot',
    order: 31,
    tabGroup: 'botSettings',
    load: () => import('./whatsapp/WhatsAppPage'),
  }),
  defineSection({
    id: 'assistant.whatsapp-link',
    area: 'clinic',
    path: 'settings/whatsapp',
    roles: settings,
    icon: Mobile,
    titleKey: 'assistantSettings:whatsapp.title',
    namespaces: ['assistant'],
    order: 221,
    nav: false,
    load: () => import('./whatsapp/WhatsAppRedirect'),
  }),
];
